module.exports = __webpack_public_path__ + "img/portraits_12_V.1151d689.webp";